{
  "cameraListPanel": {
    "text": "Cameras",
    "text2": "Select an area",
    "text3": "Remove all",
    "label": "Placed: {{length}} cameras",
    "label2": "Not placed — drag to place",
    "text4": "This area has no cameras"
  },
  "cameraRow": {
    "ariaLabel": "Remove placement of {{name}}"
  },
  "mapDeleteDialog": {
    "enqueueSnackbar": "Map deleted",
    "enqueueSnackbar2": "The map couldn't be deleted.",
    "text": "Deleting...",
    "title": "Delete map",
    "text2": "」 will be deleted. Continue?",
    "text3": "All placed cameras will also be removed. This action can't be undone."
  },
  "mapDropZone": {
    "ariaLabel": "Upload map image",
    "text": "Converting...",
    "text2": "Upload a PDF or image",
    "text3": "Drag and drop, or click to select"
  },
  "mapEditView": {
    "text": "Map management/Edit map",
    "text2": "Map management/Create map"
  },
  "mapEditViewLayout": {
    "label": "Map name",
    "label2": "Area",
    "placeholder": "Select an area",
    "label3": "Description",
    "text": "Saving...",
    "text2": "Save",
    "alt": "Floor plan of {{name}}",
    "text3": "Converting...",
    "text4": "Replace map image",
    "text5": "-page PDF. Only the first page is used.",
    "text6": "Placed cameras remain at their previous positions. Reposition them if needed.",
    "text7": "Loading...",
    "text8": "The map wasn't found.",
    "text9": "The map was deleted, or viewing it isn't permitted.",
    "text10": "This PDF doesn't include its fonts, so a substitute typeface is used. If the text looks different from the original, upload a version saved as an image.",
    "button": "Back to map management"
  },
  "mapFilterBar": {
    "placeholder": "Search by map or area name",
    "button": "Create map"
  },
  "mapImage": {
    "text": "The floor plan couldn't be loaded."
  },
  "mapManagementView": {
    "title": "Map management"
  },
  "mapManagementViewLayout": {
    "text": " maps",
    "text2": "Loading...",
    "primary": "The maps couldn't be retrieved.",
    "secondary": "Reopen the page later.",
    "primary2": "No maps",
    "secondary2": "Register a floor plan from \"Create map\"."
  },
  "mapSummaryCard": {
    "text": "No thumbnail",
    "text2": " cameras",
    "ariaLabel": "Actions for {{name}}"
  },
  "mapTable": {
    "label": "Map name",
    "label2": "Area",
    "label3": "Devices",
    "text": " cameras",
    "label4": "Description"
  },
  "mapViewModeToggle": {
    "ariaLabel": "Grid view",
    "ariaLabel2": "List view"
  },
  "useMapEditState": {
    "text": "The image couldn't be loaded.",
    "enqueueSnackbar": "Map saved",
    "text2": "The map couldn't be saved."
  },
  "canvasEncode": {
    "error": "The image couldn't be exported.",
    "error2": "The image couldn't be rendered."
  },
  "imagePipeline": {
    "error": "The image couldn't be loaded.",
    "error2": "Select a PDF, PNG, or JPEG file.",
    "error3": "The image dimensions couldn't be read."
  },
  "inputLimits": {
    "fileTooLarge": "The file is too large. Select a different file.",
    "tooManyPixels": "The image has too many pixels. Reduce its size, then select it again."
  },
  "pdfRender": {
    "error": "The image couldn't be rendered."
  },
  "directionDial": {
    "text": "Camera direction",
    "ariaLabel": "Close camera direction settings",
    "ariaLabel2": "{{direction}} degrees"
  },
  "mapCanvas": {
    "ariaLabel": "Zoom in",
    "ariaLabel2": "Zoom out"
  },
  "mapPopup": {
    "label": "Top left",
    "label2": "Top right",
    "label3": "Bottom left",
    "label4": "Bottom right",
    "label5": "Top edge",
    "label6": "Bottom edge",
    "label7": "Left edge",
    "label8": "Right edge",
    "ariaLabel": "Close map",
    "alt": "Floor plan of {{title}}",
    "ariaLabel2": "Resize map ({{label}})"
  }
}
